import * as moment from 'moment';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { PlatformLocation } from '@angular/common';
import { StoreService } from '../store';
import { find, flatMapDeep, capitalize } from 'lodash';
import * as bowser from 'bowser';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from '../config.service';

export interface ISplunkData {
	message: {
		SSID: string;
		slSSID: string;
		hitDtTm: string;
		hitType: string;
		application: string;
		appEnvrnm: string;
		virtualPage: string;
		pageTitle: string;
		sourceSession: string;
		domain: string;
		privacy?: { gpcEnabledIndicator: number; pgrCookieTrackingPrefIndicator: number };
		browser: {
			url: string;
			referrer: string;
			host: string;
			viewport: string;
		};
		event: {
			value: string;
			action: string;
			category: string;
			label: string;
			dimensions: {
				dataValue: string;
				carrierName: string;
				intRepInd: boolean;
				LANID: string;
				quoteActId: string;
				partnerCode: string;
				serverTime: number;
				networkTime: number;
				quoteRtrvl: boolean;
				experiment: string;
				optAnonConsent: string;
				quotes: [
					{
						channel: string;
						product: string;
						quoteNbr: string;
						riskType: string;
						state: string;
						sourceQuoteGUID?: string;
						quoteSource: string;
						quoteStartId: string;
					}
				];
			};
		};
		device: {
			resolution: string;
			category: string;
		};
		configuration: {
			userAgent: string;
			locale: string;
		};
	};
}
export const initialSplunkData: ISplunkData = {
	message: {
		SSID: '',
		slSSID: '',
		hitDtTm: '',
		hitType: '',
		application: '',
		appEnvrnm: '',
		virtualPage: '',
		pageTitle: '',
		sourceSession: '',
		domain: '',
		browser: {
			url: '',
			referrer: '',
			host: '',
			viewport: '',
		},
		event: {
			value: '',
			action: '',
			category: '',
			label: '',
			dimensions: {
				dataValue: '',
				carrierName: '',
				intRepInd: false,
				LANID: '',
				quoteActId: '',
				partnerCode: '',
				serverTime: 0,
				networkTime: 0,
				quoteRtrvl: false,
				experiment: '',
				optAnonConsent: '',
				quotes: [
					{
						channel: '',
						product: '',
						quoteNbr: '',
						riskType: '',
						state: '',
						quoteSource: '',
						quoteStartId: '',
					},
				],
			},
		},
		device: {
			resolution: '',
			category: '',
		},
		configuration: {
			userAgent: '',
			locale: '',
		},
	},
};

export const OPTANONCONSENT = 'OptanonConsent';
export const NEWOPTANONCONSENT = 'PgrOptOutPref';

@Injectable()
export class SplunkAnalyticsService {
	currentPage: string;
	prevPage: string;
	key: any;
	scrollEvent: any;
	elements = [];
	SPLUNK_URL: string;
	SPLUNK_RDTS: string;
	ENV: string;
	apiBaseUrl: string;

	constructor(
		private storeService: StoreService,
		private httpClient: HttpClient,
		private location: PlatformLocation,
		private cookieService: CookieService,
		private configService: ConfigService
	) {
		location.onPopState(() => {
			this.publish('Back Button', '', '');
		});
	}

	initService() {
		this.apiBaseUrl = `${this.configService.getConfig().apiBaseUrl}`;
		this.SPLUNK_URL = `${this.configService.getConfig().splunkUrl}`;
		this.SPLUNK_RDTS = `${this.configService.getConfig().splunkRTDS}`;
		this.ENV =
			`${this.configService.getConfig().ENV}` === 'bolt-production'
				? 'PRODUCTION'
				: `${this.configService.getConfig().ENV}`;
	}

	private getScreenResolution() {
		var width = screen.width;
		var height = screen.height;

		return width + 'x' + height;
	}

	private getVirualPageTitle() {
		var pathArray = window.location.pathname.split('/');
		var title = pathArray[1];
		return title;
	}
	private getBrowserResolution() {
		var width = window.innerWidth;
		var height = window.innerHeight;

		return width + 'x' + height;
	}
	private getUrlParam(param: string) {
		let url_str = window.location.href;
		let url = new URL(url_str);
		return url.searchParams.get(param);
	}
	private async postToSplunkAPI(splunkObj) {
		const globalAttributes = this.storeService.getGlobalAttributes();
		let contentType = 'application/json';
		const defaultOptions = {
			headers: { 'Content-Type': contentType, rtds_key: this.SPLUNK_RDTS }, // 'X-Bolt-SessionId': window.sessionStorage.sessionId
		};

		const body = JSON.stringify(splunkObj);
		let res = this.httpClient.post(this.SPLUNK_URL, body, defaultOptions).subscribe(
			() => {},
			() => console.log(body)
		);
	}

	publish(action: string, label: string, value?: any) {
		if (!this.apiBaseUrl) {
			this.initService();
		}
		const globalAttributes = this.storeService.getGlobalAttributes();
		const addOnParams = this.storeService.getAddOnParams();
		const splunkData: ISplunkData = initialSplunkData;
		splunkData.message.event.action = action;
		splunkData.message.hitDtTm = moment().format();
		splunkData.message.event.category = 'Bolt';
		splunkData.message.application = 'HQX';
		splunkData.message.event.label = label;
		splunkData.message.appEnvrnm = this.ENV;
		splunkData.message.domain = 'Quoting';
		splunkData.message.event.dimensions.carrierName = '';
		splunkData.message.event.dimensions.optAnonConsent = JSON.parse(sessionStorage.getItem(OPTANONCONSENT));

		if (splunkData.message.event.dimensions.optAnonConsent == null) {
			splunkData.message.event.dimensions.optAnonConsent = this.cookieService.get(OPTANONCONSENT);

			console.log(
				'splunkData.message.event.dimensions.optAnonConsent',
				splunkData.message.event.dimensions.optAnonConsent
			);
		}

		splunkData.message.event.value = '0';

		value = value == null ? '0' : value;
		if (action !== 'SysEvent' && action !== 'pageLoad' && label !== 'Carrier' && label !== 'Parent') {
			splunkData.message.event.dimensions.dataValue = value;
		} else if (
			globalAttributes['progressive-splunk-carrrier-name'] &&
			action === 'DropdownChange' &&
			(label === 'Carrier' || label === 'Parent')
		) {
			splunkData.message.event.dimensions.carrierName = value;
		} else {
			if (action === 'pageLoad') {
				splunkData.message.event.label = value.bucket;
				splunkData.message.event.dimensions.dataValue = '';
				splunkData.message.event.dimensions.serverTime = value.points[0];
				splunkData.message.event.dimensions.networkTime = value.loadTime - value.points[0];
			}
			splunkData.message.event.value = value.loadTime;
		}

		splunkData.message.virtualPage = '/' + this.getVirualPageTitle();
		splunkData.message.pageTitle = splunkData.message.virtualPage;

		if (globalAttributes) {
			if (globalAttributes.quoteRtvl) {
				splunkData.message.event.dimensions.quoteRtrvl = true;
			} else {
				splunkData.message.event.dimensions.quoteRtrvl = false;
			}
			if (globalAttributes.slSSID) {
				var str = globalAttributes.slSSID;
				//remove hyphens from guid
				splunkData.message.slSSID = str.replace(/-/g, '');
			}
			if (globalAttributes.applicationId && globalAttributes.applicationId.value) {
				splunkData.message.event.dimensions.quotes[0].quoteNbr = globalAttributes.applicationId.value;
			}
			if (globalAttributes.quoteId) {
				splunkData.message.event.dimensions.quotes[0].sourceQuoteGUID = globalAttributes.quoteId;
			}
			if (globalAttributes.category) {
				const devicetype = capitalize(bowser.getParser(window.navigator.userAgent).getPlatformType());
				splunkData.message.device.category = devicetype;
			}
			if (globalAttributes.sessionId) {
				splunkData.message.sourceSession = globalAttributes.sessionId;
				splunkData.message.event.dimensions.quoteActId = globalAttributes.sessionId;
			}
			if (globalAttributes['ccpaFlag']) {
				splunkData.message.privacy = { gpcEnabledIndicator: 0, pgrCookieTrackingPrefIndicator: 1 };

				splunkData.message.privacy.pgrCookieTrackingPrefIndicator = this.getGpcEnabledIndicator();
				splunkData.message.privacy.gpcEnabledIndicator = window.navigator['globalPrivacyControl'] ? 1 : 0;
			}
			if (globalAttributes.LANID) {
				splunkData.message.event.dimensions.LANID = globalAttributes.LANID; // Agent external Id
			}

			splunkData.message.event.dimensions.quotes[0].channel = 'Direct';

			if (globalAttributes.channel) {
				splunkData.message.event.dimensions.quotes[0].quoteSource = globalAttributes.channel;
			}
			if (globalAttributes.flowType) {
				splunkData.message.event.dimensions.intRepInd = globalAttributes.flowType === 'Agent';
			}
			if (globalAttributes.quoteState) {
				splunkData.message.event.dimensions.quotes[0].state = globalAttributes.quoteState;
			}
			if (globalAttributes.riskType) {
				splunkData.message.event.dimensions.quotes[0].riskType = globalAttributes.riskType;
			}
		}

		splunkData.message.event.dimensions.experiment = '';
		if (addOnParams) {
			let testParams = addOnParams.testParams;
			if (testParams && testParams.abtests && testParams.abtests.length != 0) {
				splunkData.message.event.dimensions.experiment = testParams.abtests.map((q) => q.replace('@', '=')).join('&');
			}
			if (addOnParams['dataLayerParams']) {
				const dataLayerParams = addOnParams['dataLayerParams'];
				if (dataLayerParams['residencyProduct']) {
					splunkData.message.event.dimensions.quotes[0].product = 'HO';
				}
				splunkData.message.event.dimensions.partnerCode = '';
				if (dataLayerParams['code'] != null && dataLayerParams['code'][0] != null) {
					const partnerCode = dataLayerParams['code'][0];
					splunkData.message.event.dimensions.partnerCode = partnerCode;
				}
				if (dataLayerParams['SSID'] != null && dataLayerParams['SSID'][0] != null) {
					const trackId = dataLayerParams['SSID'][0];
					splunkData.message.SSID = trackId;
				}
			}

			const globalAttributes = this.storeService.getGlobalAttributes();
			if (globalAttributes && globalAttributes['flowType'] == 'Consumer') {
				if (addOnParams['redirectParams'] != null) {
					const redirectParams = addOnParams['redirectParams'];
					if (redirectParams['quoteStartID'] != null && redirectParams['quoteStartID'][0] != null) {
						splunkData.message.event.dimensions.quotes[0].quoteStartId = redirectParams['quoteStartID'][0];
					}
				}
			}
		}

		splunkData.message.browser.url = window.location.href;
		splunkData.message.browser.host = window.location.host;
		splunkData.message.browser.viewport = this.getBrowserResolution();
		splunkData.message.browser.referrer = window.document.referrer;
		splunkData.message.device.resolution = this.getScreenResolution();
		splunkData.message.configuration.userAgent = navigator.userAgent;
		splunkData.message.configuration.locale = window.navigator.language;

		if (action == 'pageLoad') {
			splunkData.message.hitType = 'page';
		} else {
			splunkData.message.hitType = 'event';
		}
		if (action === 'Back Button') {
			delete splunkData.message.event['label'];
		}

		let res = this.postToSplunkAPI({ ...splunkData.message });
	}

	initsessionStorage() {
		this.key = sessionStorage.getItem('splunkKey');
		let sessionStorageObj = JSON.parse(sessionStorage.getItem(this.key));
		if (!sessionStorageObj) {
			this.key = new Date().valueOf();
			sessionStorage.setItem(this.key, JSON.stringify({}));
			sessionStorage.setItem('splunkKey', JSON.stringify(this.key));
		}
	}

	updatesessionStorage(key, item) {
		const objName = item.name.replace('[]', '');
		let obj = JSON.parse(sessionStorage.getItem(key));
		obj[objName] = item.value;
		sessionStorage.setItem(key, JSON.stringify(obj));
	}

	publishOnce(action: string, label: string) {
		if (!label) {
			return false;
		}
		if (!this.key) {
			this.initsessionStorage();
			this.publishOnce(action, label);
			return;
		}

		let sessionStorageObj = JSON.parse(sessionStorage.getItem(this.key));
		if (!sessionStorageObj) {
			return false;
		}

		label = label.replace('[]', '');

		if (sessionStorageObj && !sessionStorageObj[`splunk_${label}_Reported`]) {
			this.publish(action, label);
			this.updatesessionStorage(this.key, {
				name: 'splunk_' + label + '_Reported',
				value: true,
			});
		}
	}

	pushDisplay(label: string) {
		if (!label || label.includes('Quote')) {
			return false;
		}
		label = label.replace('[]', '');

		this.publish('Display', label);
	}

	pushDisplayOnce(label: string, route?) {
		if (!label) {
			return false;
		}

		if (!this.key) {
			this.initsessionStorage();
			this.pushDisplayOnce(label);
			return;
		}

		let sessionStorageObj = JSON.parse(sessionStorage.getItem(this.key));
		if (!sessionStorageObj) {
			return false;
		}

		label = label.replace('[]', '');

		if (sessionStorageObj && !sessionStorageObj[`splunk_${label}_Reported`]) {
			this.pushDisplay(label);
			this.updatesessionStorage(this.key, {
				name: 'splunk_' + label + '_Reported',
				value: true,
			});
		}
	}

	handelErrosEvents(data) {
		const keys = Object.keys(data.erros);
		keys.map((item) => {
			this.fireErrorEvent(item, data.renderType, data.storeData);
		});
	}

	getGpcEnabledIndicator(): number {
		// The valid values are 0, 1:
		// 1 = opted into cookie tracking (default without cookie)
		// 0 = opted out of cookie tracking
		///
		const cookie = this.cookieService.get('PgrOptOutPref');
		return cookie && cookie.length > 0 ? (cookie.slice(-1) == '1' ? 1 : 0) : 1;
	}

	fireErrorEvent(controlName, renderType, storeData) {
		let control = storeData.data.metadata[renderType]
			? this.getControl(storeData.data.metadata[renderType].controls, controlName)
			: this.getControl(storeData.data.ui.modal.controls, controlName);
		if (!control) {
			return;
		}
		let label = `${control.name}_Error`;
		label = label.replace('[]', '');

		this.publish('Display', label);
	}

	getControl(controls, name: string) {
		const control = find(controls, { name });

		if (control) {
			return control;
		} else {
			const childControls = flatMapDeep(controls, 'controls');
			return find(childControls, { name });
		}
	}
}
